window.magna ||= {}
magna.mobile ||= true
window.dataLayer = window.dataLayer || []

magna.device = () => {
  if (window.innerWidth < 420) {
    magna.mobile = true
  } else {
    magna.mobile = false
  }
}
magna.bundleBarAddToCart = async event => {
  event.preventDefault();
  event.target.setAttribute('disabled', true);
  event.target.closest('.bundle-bar__flavor').querySelector('.loading__spinner').classList.remove('hidden');
  const boxes = document.querySelector('.bundle-bar__boxes');
  if (boxes) {
    for (const box of boxes.querySelectorAll('.bundle-bar__box:not(.added)')) {
      box.querySelector('.loading__spinner').classList.remove('hidden');
      break;
    }
  }

  const id = parseInt(event.target.closest('.bundle-bar__flavor').dataset.id);
  var properties = event.target.closest('.bundle-bar__flavor').dataset.properties ? JSON.parse(event.target.closest('.bundle-bar__flavor').dataset.properties) : {};

  const url = '/cart/add.js'
  const cart_drawer = document.querySelector('cart-drawer')
  const bundle_bar_checkbox = document.querySelector('#bundle-bar-checkbox').checked;

  const items = [
    {
      id,
      quantity: 1,
      properties
    }
  ]

  window.dataLayer.push({
    event: 'add_to_cart',
    items,
  })

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items,
        sections: cart_drawer.getSectionsToRender().map(section => section.id),
        bundle_bar_checkbox: bundle_bar_checkbox
      }),
    })
    if (!response.ok) {
      throw new Error('There was a problem with the request')
    }

    const json = await response.json()
    cart_drawer.renderContents(json)
  } catch (e) {
    console.error(e.message)
    return null
  } finally {
    event.target.removeAttribute('disabled');
    event.target.closest('.bundle-bar__flavor').querySelector('.loading__spinner').classList.remove('hidden');
  }
}

magna.bundleBarRemoveFromCart = async event => {
  event.preventDefault();
  event.target.setAttribute('disabled', true);
  event.target.closest('.bundle-bar__box').querySelector('.loading__spinner').classList.remove('hidden');
  const index = event.target.closest('.bundle-bar__box').dataset.index;
  // console.log('index', index);
  if (!index) return;
  const cartItems = document.querySelector('cart-drawer-items');
  // console.log('cartItems', cartItems);
  if (!cartItems) return;
  const cartItem = cartItems.querySelector(`#CartDrawer-Item-${index}`);
  // console.log('cartItem', cartItem);
  if (!cartItem) return;
  cartItem.querySelector('.quantity__button[name="minus"]').click();
}

magna.recommendedProductAddToCart = async event => {
  event.preventDefault();
  event.target.setAttribute('disabled', true);
  event.target.classList.add('hidden');
  event.target.closest('.drawer__recommended-products-item').querySelector('.loading__spinner').classList.remove('hidden');

  // console.log('magna.recommendedProductAddToCart event -', event);

  const id = parseInt(event.target.dataset.id);
  const _dynamicBoxId = event.target.dataset.dynamicboxid;
  const _dynamicBoxIndex = parseInt(event.target.dataset.dynamicboxindex);
  const selling_plan = event.target.dataset.sellingplanid != '' ? parseInt(event.target.dataset.sellingplanid) : null;
  var properties = event.target.dataset.properties ? JSON.parse(event.target.dataset.properties) : {};
  // if (_dynamicBoxId) {
  //   properties = {
  //     _dynamicBoxId: _dynamicBoxId,
  //     _dynamicBoxIndex: _dynamicBoxIndex,
  //   }
  // }

  const url = '/cart/add.js'
  const cart_drawer = document.querySelector('cart-drawer')

  const items = [
    {
      id,
      quantity: 1,
      // selling_plan: selling_plan ? selling_plan : null,
      properties,
    }
  ]

  // console.log('magna.recommendedProductAddToCart items -', items);



  window.dataLayer.push({
    event: 'add_to_cart',
    items,
  })

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items,
        sections: cart_drawer.getSectionsToRender().map(section => section.id),
      }),
    })
    if (!response.ok) {
      throw new Error('There was a problem with the request')
    }

    const json = await response.json()
    cart_drawer.renderContents(json)
  } catch (e) {
    console.error(e.message)
    return null
  } finally {
    event.target.removeAttribute('disabled');
  }
}

magna.getMagnaButtonClickInit = () => {
  document.querySelectorAll('.get-magna--link').forEach(item =>
    item.addEventListener('click', () => {
      if (item.dataset.location === 'Bundle bar') {
        const cartDrawer = document.querySelector('cart-drawer')
        cartDrawer.close()
      }

      // Navigate to the products page
      window.location.href = '/products/magna'
      window.dataLayer.push({
        event: 'magna:get_magna_click',
        button: item.dataset.location,
      })

      setTimeout(() => {
        document.querySelector('.header__bottom')?.classList.add('header__bottom--hide')
      }, 200)
    }),
  )

  document.querySelectorAll('.get-magna--scroll').forEach(item =>
    item.addEventListener('click', event => {
      event.preventDefault()

      if (item.dataset.location === 'Bundle bar') {
        const cartDrawer = document.querySelector('cart-drawer')
        cartDrawer.close()
      }

      const scrollArea = document.querySelector('.buy_block') || document.querySelector('.buy__container') || document.querySelector('.product-preview-magna') || document.querySelector('.ctr-product-box') 
      scrollArea.scrollIntoView({
        behavior: 'smooth',
      })

      window.dataLayer.push({
        event: 'magna:get_magna_click',
        button: item.dataset.location,
      })

      setTimeout(() => {
        document.querySelector('.header__bottom')?.classList.add('header__bottom--hide')
      }, 200)
    }),
  )
  document.querySelectorAll('.get-magna--direct-link').forEach(item =>
    item.addEventListener('click', event => {
      event.preventDefault()
      if (item.dataset.location) {
        window.location.href = item.dataset.location;
        window.dataLayer.push({
          event: 'magna:get_magna_click',
          button: item.dataset.location,
        })
      }

    }),
  )
}

magna.initialize = () => {
  magna.device()
  window.addEventListener('resize', magna.device)
  magna.getMagnaButtonClickInit()
  publish(Event.domready)
  // trigger cart drawer for testing
  // document.querySelector('cart-drawer').open();
}
